import React, { Fragment, useEffect, useState, Component } from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';
import {render} from 'react-dom';
import Styles from '../styles';
import StudentFinalize from '../pages/student_finalize';
import TopBar from '../components/topbar';
import {MeasurementTest} from '../components/measurement_test';
import { Shutter } from '../pages/attend';
import { css } from '@emotion/react';
import {ShutdownPage} from '../shutdown';

export default function Preview() {
  return (
    <>
      <Switch>
        <Route path="/student/finalize" component={StudentFinalize}/>
        <Route path="/attend/shutter" component={ShutterPreview}/>
        <Route path="/attend/measurement-test">
          <MeasurementTest subject={{
            measurement_test: [{number: 1, question: 'abc'}, {number: 2, question: 'def'}]
          }}/>
        </Route>
        <Route path="/preview/shutdown" component={ShutdownPage} />
      </Switch>
    </>
  );
};

const ShutterPreview = () => {
  return <Shutter shuttingRemind={3}/>;
};
